module.exports = __webpack_public_path__ + "static/img/voice0_right.2c4a83ed.png";